import { FunctionComponent } from 'react'
import { Input, Modal, ModalBody } from 'reactstrap'
import { updateModalState } from '../../../store/search/slice'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'

const ModalEmail: FunctionComponent = () => {
  const dispatch = useAppDispatch()
  const isModalOpen = useAppSelector((state) => state.search.isModalOpen)
  return (
    <Modal isOpen={isModalOpen} backdrop={true} centered={true} size="lg">
      <ModalBody>
        <div className="modalEmail__header">
          Sorry, we aren't in your area yet
        </div>
        <div className="modalEmail__text">
          Sign up with MHBO.com and we'll notify you when we arrive
        </div>
        <Input className="modalEmail__signup" placeholder="example@email.com" />
        <button
          className="modalEmail__button"
          onClick={() => {
            dispatch(updateModalState(false))
          }}
        >
          Submit
        </button>
      </ModalBody>
    </Modal>
  )
}

export default ModalEmail
